import { cn } from '@/utils/merge';
import useWindowSize from '@/utils/useWindowSize';
import { useLayoutEffect, useRef, useState } from 'react';

const Tabs = ({ tabItems, middleComponent, styleContainer }) => {
	const [selected, setSelectedIndex] = useState(0);
	// A caller's tab list can shrink while a later tab is selected (Statistics
	// drops its pay tabs when the city's pay system is switched off): fall back
	// to the last tab that still exists instead of reading past the end.
	const selectedIndex = Math.min(selected, tabItems.length - 1);
	const [indicatorStyle, setIndicatorStyle] = useState(null);

	const { width } = useWindowSize();
	const tabsRef = useRef([]);

	// Measured in a layout effect, not during render: on the first render the refs
	// are not attached yet, so reading them in a useMemo left the indicator at
	// zero width until something else happened to invalidate the memo.
	useLayoutEffect(() => {
		const currentTab = tabsRef.current[selectedIndex];

		if (!currentTab) return;

		const next = {
			width: currentTab.offsetWidth,
			transform: `translateX(${currentTab.offsetLeft}px)`,
		};

		setIndicatorStyle(prev =>
			prev && prev.width === next.width && prev.transform === next.transform ? prev : next,
		);
	}, [selectedIndex, tabItems.length, width]);

	return (
		<div className='flex w-full flex-col' style={styleContainer}>
			<div className='relative flex w-fit rounded-xl border-[1px] border-[#0f9b9d] px-1 py-0'>
				{/* Rolling background */}
				<div
					className='absolute top-1 bottom-1 left-0 rounded-lg bg-slate-300 transition-all duration-200 ease-in-out'
					style={indicatorStyle}
				/>

				{tabItems.map((tab, idx) => {
					return (
						<button
							key={tab.label}
							ref={el => (tabsRef.current[idx] = el)}
							onClick={() => setSelectedIndex(idx)}
							className={cn(
								`relative z-0 cursor-pointer py-2 text-sm font-medium !text-slate-600 transition-colors duration-200`,
								// selected && '!text-white',

								'px-4',
								'min-[500px]:text-lg',
							)}
						>
							{tab.label}
						</button>
					);
				})}
			</div>

			{middleComponent}

			<div className={cn('mt-1', 'min-[1500px]:mt-2.5')}>{tabItems[selectedIndex].content}</div>
		</div>
	);
};

export default Tabs;
